import { Card, CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';
import { theme } from '../theme';

interface Props {
  count: number;
  testId: string;
}

export function CommentableSkeleton({ count, testId }: Props) {
  return (
    <Grid container data-testid={testId}>
      {Array.from({ length: count }, (_, index) => (
        <Grid key={index} item={true} xs={12}>
          <Card>
            <CardHeader
              title={<Skeleton width={theme.spacing(30)} height={theme.spacing(3)} />}
              style={{
                backgroundColor: theme.palette.secondary.light,
              }}
            />
            <Divider />
            <CardContent>
              <Skeleton />
              <Skeleton />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
